import { List, ListItem } from "@mui/material";
import { Bomstasjon } from "../../services/RuteplanAPI";
import { IRoutePartProps } from "./RouteDescription";
import bomstasjonIconSource from "../../assets/tollbooth.svg"

export default function Bomstasjoner(props: IRoutePartProps) {

    return (    
        <>
            {props.roadFeatures && props.roadFeatures.bomstasjoner && props.roadFeatures.bomstasjoner.length > 0 && 
            <List >
                {props.roadFeatures.bomstasjoner.map( (bomstasjon: Bomstasjon, index: number) => (
                    <ListItem 
                        key={bomstasjon.navn + index} 
                        className="roadFeature" 
                        onClick={(event) => {props.onClick(bomstasjon, event)}}
                        onMouseEnter={() => props.onMouseEnterItem(bomstasjon)}
                        onMouseLeave={props.onMouseLeaveItem}>
                        <img src={bomstasjonIconSource} height="24" style={{paddingRight:"5px"}} alt="Bomstasjon icon" title="bomstasjonIcon"/> 
                        {bomstasjon.navn}
                    </ListItem>
                ))}
            </List>        
            }
        </>    
    )
}